import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormGroup,
} from "@mui/material";
import React from "react";

const Comp7PDF = ({
    formData,
    checked
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">SDGs 子ども・ユースフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">給排水・エア・ガス申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_7_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_7_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_7_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_7_tel}</Box>
            </Box>
            <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            給排水・エア・ガス工事
            </Typography>
            <FormGroup row>
                <FormControlLabel
                control={<Checkbox name="water" checked={checked.water} />}
                label="給排水工事を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="air" checked={checked.air} />}
                label="エア工事を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="gas" checked={checked.gas} />}
                label="ガス工事を希望する"
                />
            </FormGroup>

            {checked.water && (
                <>
                <Typography variant="subtitle1">給排水</Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                用途 ： {formData?.water_using}
                </Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                使用量（リットル/分） ： {formData?.water_quantity}
                </Typography>

                <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">給水管</FormLabel>
                    <RadioGroup row name="water_pipe" value={formData?.water_pipe}>
                    <FormControlLabel value="13mm" control={<Radio />} label="ビニール管13mm　93,500円（税込）　　　　　　　　　　" />
                    <FormControlLabel value="20mm" control={<Radio />} label="ビニール管20mm　99,000円（税込）　　　　　　　　　　" />
                    <FormControlLabel value="25mm" control={<Radio />} label="ビニール管25mm　104,500円（税込）　　　　　　　　　　" />
                    </RadioGroup>
                </FormControl>

                <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">排水管</FormLabel>
                    <RadioGroup row name="water_ex_pipe" value={String(formData?.water_ex_pipe)}>
                    <FormControlLabel value="true" control={<Radio />} label="40mm" />
                    <FormControlLabel value="false" control={<Radio />} label="50mm" />
                    </RadioGroup>
                </FormControl>
                </>
            )}

            {checked.air && (
                <>
                <Typography variant="subtitle1">エア</Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                圧力（MPa） ： {formData?.air_pascal}
                </Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                風量（リットル/分） ： {formData?.air_wind}
                </Typography>

                <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">機器接続</FormLabel>
                    <RadioGroup row name="air_device" value={String(formData?.air_device)}>
                    <FormControlLabel value="true" control={<Radio />} label="あり" />
                    <FormControlLabel value="false" control={<Radio />} label="なし" />
                    </RadioGroup>
                </FormControl>

                <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">バルブ</FormLabel>
                    <RadioGroup row name="bulb" value={String(formData?.bulb)}>
                    <FormControlLabel value="true" control={<Radio />} label="13mm" />
                    <FormControlLabel value="false" control={<Radio />} label="20mm" />
                    </RadioGroup>
                </FormControl>
                </>
            )}

            {checked.gas && (
                <>
                <Typography variant="subtitle1">ガス</Typography>
                <Typography>希望する詳細内容をご入力ください。</Typography>
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {formData?.gas}
                </Typography>
                </>
            )}

            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp7PDF;
